export class FixType {
  static get RemoveFix () {
    return 1
  }
  static get MoveFix () {
    return 2
  }
  static get RepairFix () {
    return 3
  }
  static get MovieLook () {
    return 6
  }
  static get Photo () {
    return 7
  }
  static get AuthorizeInstall () {
    return 80
  }
  static get AuthorizeRemove () {
    return 81
  }
  static get Info () {
    return 9
  }
  static get Prepayment () {
    return 10
  }
  static get Complaint () {
    return 11
  }
  static get TryInstallFix () {
    return 12
  }
  static get TryInstallRepairFix () {
    return 13
  }

  static FixTypeName (FixType) {
    let tmpType = parseInt(FixType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '拆機'
        break
      case 2:
        name = '移機-拆'
        break
      case 3:
        name = '維修'
        break
      case 6:
        name = '影像調閱'
        break
      case 7:
        name = '送審拍照'
        break
      case 80:
        name = '授權-裝機'
        break
      case 81:
        name = '授權-拆機'
        break
      case 9:
        name = '補資訊'
        break
      case 10:
        name = '預繳'
        break
      case 11:
        name = '客訴'
        break
      case 12:
        name = '試裝-拆'
        break
      case 13:
        name = '試裝-維修'
        break
    }
    return name
  }
}
